module.exports = " <div class=day-overlay> <template v-for=\"div in 95\"> <div></div> </template> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/SingleDayOverlay.vue
// module id = 333
// module chunks = 2